import React from "react"
import { Spacer, CmsImage } from "@bw/bits"
import * as Icons from "@bw/icons"
import styled from "styled-components"

const StyledSocialLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  text-decoration: none;
  background: transparent;
  font-size: 12px;
  font-weight: 400;
  line-height: 135.5%;
  color: #04062c;
  opacity: 1;
  transition: all 0.3s ease-in-out;

  &:hover {
    transform: scale(1.2);
    text-decoration: underline;
    opacity: 0.5;
    > * {
      fill: ${props =>
        props.fillColorFacebook
          ? "blue"
          : props.fillColorInsta
          ? "blue"
          : "black"};
    }
  }
`

const Socials = ({ networks }) => {
  if (!networks) {
    return null
  }

  return (
    <Spacer direction="row" gap="medium">
      {networks &&
        networks.map((network, i) => {
          const iconName =
            network.networkType.value.charAt(0).toUpperCase() +
            network.networkType.value.slice(1).toLowerCase()

          let icon

          if (iconName === "Other") {
            icon = <CmsImage src={network.networkIcon.url} alt="" />
          } else {
            let Icon =
              typeof Icons[iconName] !== "undefined" ? Icons[iconName] : null
            icon = (
              <Icon fillColor="var(--primary)" width="15px" height="15px" />
            )
          }

          return (
            <StyledSocialLink
              key={i}
              href={network.networkUrl}
              rel="noreferrer nofollow"
              target="_blank"
            >
              <div>{icon}</div>
            </StyledSocialLink>
          )
        })}
    </Spacer>
  )
}

export { Socials }
